// extracted by css-extract-rspack-plugin
export default {"tabs":"Tabs__tabs--cAsfP","withContract":"Tabs__withContract--p4MEa"};